<template>
  <div class="left">
      <div class="peopleInfo font-MT">
          <template>
              <div class="topbook">
                  <img :src="bookdetail.iiconUrlMedium" alt=""/>
              </div>
              <p class="name f16 text-333  text-hidden">{{ bookdetail.iname}}</p>
              <p class="words f14 text-muted"><i class="mr5">{{bookdetail.chapterCount}}</i>章 |  {{bookdetail.words}} 字 ｜ {{bookdetail.inspectStatus == 0 ? '待提交审核' : bookdetail.inspectStatus == 1 ? '审核中': bookdetail.inspectStatus == 2 ? '审核通过' : bookdetail.inspectStatus == -2 ? '审核驳回' :''}} </p>
          </template>
      </div>
      <ul class="person-center author-bar">
          <li class="f18 font-MT text-333" v-for="(item, index) in navlist" :key="item.name">
              <router-link
                      class="text-333 flexible aItem-center"
                      :to="item.url"
                      :class="index == 0 && $route.path.includes('author/authorManage/chapterList')?'active-li':''"

              >
                  <img :src="($route.path  == item.url || (index == 0 && $route.path.includes('author/authorManage/chapterList'))) ? item.icon1 : item.icon"/>
                  {{ item.name }}
              </router-link>
          </li>
      </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
import baseURL from "@/api/env";
export default {
      props: {
        navlist: Array,
        bookdetail: Object
      },
    data () {
        return{
            // imgURL: baseURL.IMG,
        }
    },
//   computed: mapState({
//     info: state => (state.user.img ? state.user.img : null)
//   }),
  methods: {

  }
};
</script>

<style lang="scss" scoped>
    @import "@/styles/author.scss";
    .peopleInfo{
        width: 240px;
        margin: auto;
        .topbook{
            text-align: center;
            margin-top: 40px;
            img{
                width: 172px;
                height: 240px;
            }
        }
        .name{
            width: 187px;
            margin: auto;
            margin-top: 16px;
            line-height: 28px;
            line-clamp: 2;
            -webkit-line-clamp: 2;
            text-align: center;
        }
        .words{
            // border-top: 1px solid #EEEEEE;
            width: 187px;
            margin: auto;
            padding: 12px 20px 0;
            text-align: center;
            i{
                // color: #7DB36C;
            }
        }
    }
    .author-bar{
        margin-top: 40px;
    }
    .active-li{
        background: #FFF6EB;
        color: #F68A01 !important;
    }
</style>
